import { defineMessages } from "react-intl";
const messages = defineMessages({
    tooltipMonitor: {
        id: "app.admin.aiDiscoverability.quadrantChart.tooltip.monitor",
        defaultMessage: "These sources have low importance but your community is performing well. Keep an eye on them but don't prioritize.",
    },
    tooltipMaintain: {
        id: "app.admin.aiDiscoverability.quadrantChart.tooltip.maintain",
        defaultMessage: "These sources are highly important and your community is performing well. Maintain your presence here.",
    },
    tooltipImprove: {
        id: "app.admin.aiDiscoverability.quadrantChart.tooltip.improve",
        defaultMessage: "These sources have low importance and your community is underperforming. Consider improving your presence as time allows.",
    },
    tooltipPriorityFix: {
        id: "app.admin.aiDiscoverability.quadrantChart.tooltip.priorityFix",
        defaultMessage: "These sources are highly important but your community is underperforming compared to the top performer. Focus your efforts here.",
    },
});
export default messages;
